import {
    getActiveCaptchaProvider,
    getCaptchaField,
    getGoogleV2SiteKey,
    getGoogleV3SiteKey,
    getTurnstileSiteKey,
} from './captcha';

/**
 * Initialize captcha configuration as window global for blade compatibility.
 * This must be called before any captcha component is used.
 */
export function initializeCaptchaGlobals(): void {
    const provider = getActiveCaptchaProvider();
    window.CAPTCHA_FIELD_NAME = getCaptchaField();
    window.CAPTCHA_PROVIDER = provider;
    window.CAPTCHA_SITE_KEY =
        provider === 'turnstile' ? getTurnstileSiteKey() : getGoogleV3SiteKey() || getGoogleV2SiteKey();
}
